import { render, staticRenderFns } from "./ImportedSalesHistory.vue?vue&type=template&id=31e517ee&scoped=true"
import script from "./ImportedSalesHistory.vue?vue&type=script&lang=js"
export * from "./ImportedSalesHistory.vue?vue&type=script&lang=js"
import style0 from "./ImportedSalesHistory.vue?vue&type=style&index=0&id=31e517ee&prod&scoped=true&lang=css"
import style1 from "./ImportedSalesHistory.vue?vue&type=style&index=1&id=31e517ee&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e517ee",
  null
  
)

export default component.exports